import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import assets from "../../assets";
import "./style.sass";
import useHandler from "./handler";
import { ROUTE_DASHBOARD } from "../../route/communicative";
import { SessionSummaryCard } from "../../common-components/score-card";

const SUGGESTED_TOPICS = [
  "The Role of AI in Education",
  "How to Protect Our Environment",
  "Benefits of Sports & Exercise",
  "Importance of Reading Books",
  "My Dream Career & Goals",
  "Social Media Pros and Cons",
];

const WritingPractice = () => {
  const navigate = useNavigate();
  const {
    loading,
    evaluation,
    showEvaluation,
    setShowEvaluation,
    evaluateWriting,
  } = useHandler();
  const [topic, setTopic] = useState("");
  const [content, setContent] = useState("");
  const [mode, setMode] = useState("type"); // "type" or "upload"
  const [file, setFile] = useState(null);

  const goToDashboard = () => navigate(ROUTE_DASHBOARD);

  const wordCount = content.trim() ? content.trim().split(/\s+/).length : 0;

  const handleFileUpload = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) setFile(uploadedFile);
  };


const EvaluationView = () => {
  const metrics = [
    {
      label: "Grammar",
      score: evaluation?.grammar_score || 0,
      tag: evaluation?.grammar?.label || "",
    },
    {
      label: "Vocabulary",
      score: evaluation?.vocabulary_score || 0,
      tag: evaluation?.vocabulary?.label || "",
    },
    {
      label: "Coherence",
      score: evaluation?.coherence_score || 0,
      tag: evaluation?.coherence?.label || "",
    },
    {
      label: "Fluency",
      score: evaluation?.fluency_score || 0,
      tag: evaluation?.fluency?.label || "",
    },
  ];

  return (
    <div className="evaluation_container">
      <div className="eval_header">
        <h1>Writing Evaluation</h1>
        <div className="topic_name">
          Review your performance and get AI feedback for "{topic}"
        </div>
      </div>

      <SessionSummaryCard
        score={evaluation?.overall_score || 0}
        max={100}
        title={evaluation?.score_heading}
        message={evaluation?.feedback}
        metrics={metrics}
      />

      <div className="improved_version">
        <div className="version_header">🪄 Improved Version</div>
        <div className="version_content">{evaluation?.corrected_version}</div>
      </div>
    </div>
  );
};

  return (
    <div className="writing_practice">
      <header className="writing_header">
        <div className="header_left">
          <img src={assets.ic_logo} alt="Rovian AI" className="logo" />
          <span className="logo_title">Rovian AI</span>
        </div>
        <div className="back_link" onClick={goToDashboard}>
          <img
            src={assets.ic_back_arrow || ""}
            alt=""
            style={{ transform: "rotate(0deg)", width: "12px" }}
          />{" "}
          Dashboard
        </div>
      </header>

      <main className="writing_main">
        {showEvaluation ? (
          <EvaluationView />
        ) : (
          <div className="writing_container">
            <div className="writing_card">
              <div className="card_header">
                <h1>Writing Practice</h1>
                <p className="subtitle">
                  Write on any topic and get instant AI feedback.
                </p>
              </div>

              <div className="form_group">
                <label>Topic</label>
                <input
                  type="text"
                  placeholder="e.g. The importance of learning languages"
                  value={topic}
                  onChange={(e) => setTopic(e.target.value)}
                />
                <div className="topic_tags_header">
                  <span className="topic_tags_label">Suggested Topics</span>
                </div>
                <div className="topic_tags">
                  {SUGGESTED_TOPICS.map((t) => (
                    <button
                      key={t}
                      type="button"
                      className={`tag ${topic === t ? "active" : ""}`}
                      onClick={() => setTopic(t)}
                    >
                      <span className="tag_dot" />
                      <span className="tag_text">{t}</span>
                      {topic === t && <span className="tag_check">✓</span>}
                    </button>
                  ))}
                </div>
              </div>

              <div className="form_group">
                <div className="form_header_row">
                  <label>Your Answer</label>
                  <div className="mode_toggle">
                    <button
                      className={mode === "type" ? "active" : ""}
                      onClick={() => setMode("type")}
                    >
                      Type
                    </button>
                    <button
                      className={mode === "upload" ? "active" : ""}
                      onClick={() => setMode("upload")}
                    >
                      Upload
                    </button>
                  </div>
                </div>

                {mode === "type" ? (
                  <>
                    <textarea
                      placeholder="Type or paste your essay here..."
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                    />
                    <div className="word_count">{wordCount} words</div>
                  </>
                ) : (
                  <div
                    className="upload_container"
                    onClick={() =>
                      document.getElementById("file_input").click()
                    }
                  >
                    <input
                      type="file"
                      id="file_input"
                      hidden
                      accept=".pdf,.doc,.docx"
                      onChange={handleFileUpload}
                    />
                    <svg
                      className="upload_icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
                    </svg>
                    <div className="upload_text">
                      {file
                        ? `Uploaded: ${file.name}`
                        : "Click to upload your answer sheet"}
                    </div>
                    <div className="upload_limit">Max 1MB</div>
                  </div>
                )}
              </div>

              <button
                className="submit_btn"
                disabled={
                  loading || (!content.trim() && !file) || !topic.trim()
                }
                onClick={() => evaluateWriting(topic, content, file)}
              >
                {loading ? "Evaluating..." : "Submit for Evaluation"}
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default WritingPractice;
